/* istanbul ignore file */
import PersonCard from './PersonCard';

export default PersonCard;
